import type { ReactElement } from 'react'

import { Box } from '@twisto/components/atoms/box'
import { Typography } from '@twisto/components/atoms/typography'

import * as styles from './installment-offer-schedule-table.styles'

type Props = {
  endAdornment: ReactElement
  children: ReactElement
}
export const Row = ({ children, endAdornment }: Props) => (
  <Box
    color="transparent"
    css={styles.infoRow}
    endAdornment={
      <Typography color="textPrimary" variant="b3">
        {endAdornment}
      </Typography>
    }
  >
    <Typography color="textSecondary" variant="b3">
      {children}
    </Typography>
  </Box>
)
